module.exports = __webpack_public_path__ + "img/i-5.af471c3e.svg";